<ng-container *ngIf="!hasError; else portfolioErrorTemplate">
  <page-header [title]="pageTitle">
    <div *ngIf="moreThanOneSponsor">
      <client-switcher-dropdown
        *ngIf="!isLoading"
        #sponsorDd
        [sponsors]="sponsorNames"
        [sponsorSelected]="sponsorSelected"
        (applyClicked)="onDropdownApply($event)"
      >
      </client-switcher-dropdown>
      <confirmation-modal
        [open]="switchOpen"
        [sponsor]="pendingSponsor"
        [title]="'Confirm switching sponsor'"
        confirmLabel="Yes, switch"
        cancelLabel="No, cancel"
        (closed)="onSponsorSwitchModalClosed($event)"
      >
      </confirmation-modal>
    </div>
  </page-header>
  <portfolio-skeleton
    *ngIf="isLoading"
    class="study-portfolio-skeleton"
    [ngClass]="{
      'collapsed-app-content': sidebarCollapsed,
      'expanded-app-content': !sidebarCollapsed
    }"
  ></portfolio-skeleton>

  <section
    *ngIf="!isLoading && !hasError"
    class="study-portfolio-section"
    [ngClass]="{
      'collapsed-app-content': sidebarCollapsed && !isLoading,
      'expanded-app-content': !sidebarCollapsed && !isLoading
    }"
  >
    <div class="portfolio-summary-title-container">
      <div class="portfolio-summary-title">
        <span>Portfolio summary</span>
        <svg
          width="1"
          height="22"
          viewBox="0 0 1 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="1" height="22" fill="#CCCCCC" />
        </svg>
        <span class="portfolio-summary-count"
          >{{ displayedData.length }} of {{ currentStudiesDisplayed }} studies</span
        >
        <svg
          *ngIf="moreThanOneSponsor"
          width="1"
          height="22"
          viewBox="0 0 1 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="1" height="22" fill="#CCCCCC" />
        </svg>
        <span *ngIf="moreThanOneSponsor" class="portfolio-sponsor-representation">
          {{ sponsorSelected === 'All' ? sponsorNames.length + ' sponsors' : sponsorSelected }}
        </span>
      </div>
      <chips-list></chips-list>
    </div>
    <distribution-charts
      (expandRequested)="openExpandedView()"
      [isSidebarCollapsed]="sidebarCollapsed"
      [sortedTherapeuticAreaData]="sortedStudiesByTherapeuticArea"
      [sortedPhaseData]="sortedStudiesByPhase"
      [sortedStageData]="sortedStudiesByStage"
      [sortedAcceleratorData]="sortedStudiesByAccelerator"
    >
    </distribution-charts>
  </section>

  <section
    *ngIf="!isLoading && !hasError"
    class="study-portfolio-kpi-section"
    [ngClass]="{
      'collapsed-app-content': sidebarCollapsed && !isLoading,
      'expanded-app-content': !sidebarCollapsed && !isLoading
    }"
  >
    @if (isKpiLoading) {
      <simple-card
        [cardTitle]="'Portfolio KPIs'"
        [showHeader]="true"
        [id]="'portfolio-kpis'"
        [className]="'portfolio-kpis-card'"
        [contentLayout]="'default'"
        [style]="{ width: '66%' }"
      >
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          class="flex-kpi-item"
          [theme]="{
            width: '196px',
            height: '172px',
            margin: '0px 8px 8px 8px'
          }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          class="flex-kpi-item"
          [theme]="{
            width: '196px',
            height: '172px',
            margin: '0px 8px 8px 8px'
          }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          class="flex-kpi-item"
          [theme]="{
            width: '196px',
            height: '172px',
            margin: '0px 8px 8px 8px'
          }"
        ></ngx-skeleton-loader>
      </simple-card>
    } @else {
      <simple-card
        [cardTitle]="'Portfolio KPIs'"
        [showHeader]="true"
        [id]="'portfolio-kpis'"
        [className]="'portfolio-kpis-card'"
        [contentLayout]="'default'"
        [style]="{ width: '66%' }"
      >
        <ng-container *ngFor="let kpi of kpis | keyvalue">
          <kpi
            *ngIf="kpi.value"
            [kpi]="kpi.value"
            [kpiKey]="getKpiKey(kpi.key)"
            [isSelected]="false"
            [tooltipEnabled]="tooltipsEnabled"
            (kpiSelected)="handleKpiSelection($event)"
            class="flex-kpi-item"
          ></kpi>
        </ng-container>
      </simple-card>
    }
    <div style="width: 34%">
      <feedback-card
        containerDirection="row"
        containerPadding="16px 67px"
        containerBorderColor="#CCCCCC"
        iconContainerPosition="relative"
        iconContainerMarginTop="0px"
        iconPosition="absolute"
        iconTop="15px"
        iconRight="15px"
        footerTop="15px"
        [feedbackBody]="
          'Your input goes straight to our product team to guide future improvements.'
        "
        (openRequested)="onFeedbackOpenRequested($event)"
      >
      </feedback-card>

      <confirmation-modal
        [open]="showModal"
        [title]="'Redirecting to email'"
        [message]="
          'You are about to be redirected outside of Clinical Decision Suite. Your default email client will provide an email address where you can send your feedback.\n\n\nDo you want to continue?'
        "
        confirmLabel="Continue"
        cancelLabel="Cancel"
        (closed)="onFeedbackModalClosed($event)"
      >
      </confirmation-modal>
      <provider-modal
        [open]="showProviderModal"
        [title]="'Select email provider'"
        (selected)="onProviderSelected($event)"
      >
      </provider-modal>
    </div>
  </section>

  <section
    *ngIf="!isLoading"
    class="study-portfolio-section"
    [ngClass]="{
      'collapsed-app-content': sidebarCollapsed && !isLoading,
      'expanded-app-content': !sidebarCollapsed && !isLoading
    }"
  >
    <div class="table-heading">
      <span>My studies</span>
      <filter-menu
        ngClass="filter-menu"
        [totalFiltersApplied]="totalFiltersApplied"
        [columnTitleMappings]="columnTitleMapping"
        (toggleMenuEvent)="toggleMenu($event.event, $event.column)"
        (closeMenuEvent)="closeMenu()"
      ></filter-menu>
    </div>
    <div class="study-portfolio-table">
      <div class="table-container" [ngStyle]="{ 'min-height': hasData ? '440px' : '0px' }">
        <table mat-table matSort [dataSource]="tableData" class="mat-table" matSortDisabled>
          <ng-container
            *ngFor="let column of displayedColumns"
            [matColumnDef]="column"
            [sticky]="columnConfigurations[column]?.isSticky"
          >
            <th
              mat-header-cell
              *matHeaderCellDef
              [class.hoverable-header]="columnConfigurations[column]?.hasHeaderMenu"
            >
              {{ columnConfigurations[column]?.displayName
              }}<header-menu
                *ngIf="columnConfigurations[column]?.hasHeaderMenu"
                [field]="column"
                [columnName]="column"
                [currentSortColumn]="currentSortColumn"
                [currentSortDirection]="currentSortDirection"
                (sortRequested)="onMenuSort($event, column)"
              ></header-menu>
            </th>
            <td mat-cell *matCellDef="let element">
              <ng-container
                *ngIf="columnConfigurations[column]?.hasCustomContent; else defaultCell"
              >
                <ng-container [ngSwitch]="true">
                  <ng-container *ngSwitchCase="column === 'protocolNumber'">
                    <a
                      [routerLink]="['study-details', element.studySk]"
                      cdkOverlayOrigin
                      #protocolOrigin="cdkOverlayOrigin"
                      (mouseenter)="onProtocolMouseEnter(element)"
                      (mouseleave)="onProtocolMouseLeave()"
                    >
                      {{ element.protocolNumber !== 'NULL' ? element.protocolNumber : '' }}
                    </a>

                    <cds-tooltip
                      [origin]="protocolOrigin"
                      [open]="protocolTooltipElement === element && protocolTooltipOpen"
                      placement="right"
                      [panelWidth]="256"
                      [hasBackdrop]="false"
                      (hovered)="onProtocolTooltipHover()"
                      (unhovered)="onProtocolTooltipLeave()"
                    >
                      <ng-template #tooltipContent>
                        <div class="protocol-tooltip-header">
                          {{ element.protocolNumber }}
                        </div>
                        <div class="protocol-tooltip-body">
                          {{ element.protocolDesc }}
                        </div>
                      </ng-template>
                    </cds-tooltip>
                  </ng-container>

                  <ng-container
                    *ngSwitchCase="column === 'country' && element[column] === 'Multiple'"
                  >
                    <button
                      class="countries-tooltip"
                      type="button"
                      cdkOverlayOrigin
                      #countryOrigin="cdkOverlayOrigin"
                      (click)="toggleCountryTooltip(element)"
                      [class.active-tooltip]="countryTooltipElement === element"
                    >
                      Multiple
                    </button>

                    <cds-tooltip
                      [origin]="countryOrigin"
                      [open]="countryTooltipElement === element"
                      (openChange)="onCountryTooltipChange($event, element)"
                      [tooltipId]="'country-tooltip-' + element.studySk"
                      [hasBackdrop]="false"
                      [closeOnOutsideClick]="true"
                      [panelWidth]="256"
                      panelWidth="auto"
                    >
                      <ng-template #tooltipContent>
                        <div class="country-tooltip-header">
                          Countries: {{ element.countryList.length }}
                        </div>
                        <div class="country-tooltip-list">
                          <div *ngFor="let item of element.countryList">• {{ item }}</div>
                        </div>
                      </ng-template>
                    </cds-tooltip>
                  </ng-container>

                  <ng-container
                    *ngSwitchCase="column === 'region' && element[column] === 'Multiple'"
                  >
                    <p>Multiple</p>
                  </ng-container>
                  <ng-container *ngSwitchCase="column === 'milestoneStatus'">
                    <status-badge
                      [type]="'portfolioMilestone'"
                      [badgeKey]="element[column]"
                    ></status-badge>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{ element[column] !== 'NULL' ? (element[column] ?? '') : '' }}
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #defaultCell>
                {{ element[column] !== 'NULL' ? (element[column] ?? '') : '' }}
              </ng-template>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <!-- <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="9">
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <no-results></no-results>
          </td>
        </tr> -->
        </table>
      </div>
      @if (!hasData) {
        <div class="no-results-container" [style]="{ height: '100%' }">
          <no-results></no-results>
        </div>
      } @else {
        <core-pagination
          #paginator
          *ngIf="showPaginator"
          class="study-portfolio-pagination"
          [attr.activepage]="currentPage"
          [attr.resultsperpage]="activeResultsPerPage"
          [attr.activeresultsperpage]="activeResultsPerPage"
          [attr.totalresults]="totalResults"
          (activePageChange)="onPageChange($event)"
          variants="{{ paginationVariants }}"
        >
        </core-pagination>
      }
    </div>
  </section>
</ng-container>

<ng-template #portfolioErrorTemplate>
  <error-view [type]="'something-went-wrong'"></error-view>
</ng-template>
